module.exports = __webpack_public_path__ + "static/media/paypal_example_mail.c774fb39.png";